import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, extend, fetch2 } from '../utils';
import Searcher from './Searcher';
import Icons from "../resources/icons";
/**
 *
 * @class Searches gst geoservice (http://www.kortforsyningen.dk/dokumentation/geonoeglergeosearch)
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.GeoStednavnSearch
 * @param {Object} options GeoSearch expects these properties:
 * @param options.area {string} "muncode" + municipalitycode eg.; "muncode0151"
 * @param options.authParams {Object} Either {ticket: 'ttttt'}, where t is a ticket issued by kortforsyningen or {login: 'lll', password: 'pppp'}
 *
 * @example
 * var geoStednavnSearchOptions = {
 *     onSelect : function(result) {
 *          log('<b>'+ result.data.type + ':</b> '+ result.title + '<br/>');
 *     },
 *     area: "muncode0151",
 *     authParams: {
 *      login: 'xxxx',
 *      password: 'xxxxxx'
 *     }
 * };
 * searchers.push({title : 'GeoSearch Feature', searcher : new Septima.Search.GeoStednavnSearch(geoStednavnSearchOptions)});
 *
 */

export default Class(Searcher, {
  serviceUrl: 'https://kortforsyningen.kms.dk',
  initialize: function initialize(options) {
    this.options = options;
    options.usesGeoFunctions = true;
    if (!options.source) options.source = "Kortforsyningen";
    this.source = options.source;
    this.Searcher(options);
    this.type = {
      id: "stednavne",
      singular: "Stednavn",
      plural: "Stednavne"
    };
    this.registerType(this.source, this.type);
    this.area = null;

    if (options.kommunekode) {
      var municipalities = options.kommunekode.split(' ');

      for (var i = 0; i < municipalities.length; i++) {
        municipalities[i] = "muncode0" + municipalities[i];
      }

      this.area = municipalities.join();
    } else if (options.area) {
      this.area = options.area;
    }

    this.authParams = options.authParams;
    this.visUOfficiel = false;
    if (options.visUOfficiel) this.visUOfficiel = options.visUOfficiel;
    this.iconURI = Icons.searchers.geoSearch.result;
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = caller;
              _context.next = 3;
              return this.query(query);

            case 3:
              _context.t1 = _context.sent;

              _context.t0.fetchSuccess.call(_context.t0, _context.t1);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  query: function () {
    var _query2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(_query) {
      var results, items, count, title, hitsShown, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, _title;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              results = this.createQueryResult();
              _context2.next = 3;
              return this.fetchItems(_query, Math.max(_query.limit, 100) + 1);

            case 3:
              items = _context2.sent;
              count = items.length;

              if (!(_query.type === 'collapse')) {
                _context2.next = 9;
                break;
              }

              if (count > 0) {
                title = this.type.plural;
                if (!_query.isBlank) if (count > Math.max(_query.limit, 100)) title += " (".concat(Math.max(_query.limit, 100), "+)");else title += " (".concat(count, ")");
                results.addNewQuery(this.source, this.type.id, title, null, _query.queryString, null, null);
              }

              _context2.next = 30;
              break;

            case 9:
              hitsShown = count === 1 ? 1 : _query.type === 'no-cut' && count > _query.limit ? 0 : Math.min(count, _query.limit);
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 13;

              for (_iterator = items.slice(0, hitsShown)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                item = _step.value;
                this.addItemAsResult(results, item);
              }

              _context2.next = 21;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](13);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 21:
              _context2.prev = 21;
              _context2.prev = 22;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 24:
              _context2.prev = 24;

              if (!_didIteratorError) {
                _context2.next = 27;
                break;
              }

              throw _iteratorError;

            case 27:
              return _context2.finish(24);

            case 28:
              return _context2.finish(21);

            case 29:
              if (count > hitsShown && ["no-cut", "cut"].indexOf(_query.type) !== -1) {
                _title = this.type.plural;
                if (!_query.isBlank) if (count > Math.max(_query.limit, 100)) _title += " (".concat(Math.max(_query.limit, 100), "+)");else _title += " (".concat(count, ")");
                results.addNewQuery(this.source, this.type.id, _title, null, _query.queryString, null, null);
              }

            case 30:
              return _context2.abrupt("return", results);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[13, 17, 21, 29], [22,, 24, 28]]);
    }));

    function query(_x3) {
      return _query2.apply(this, arguments);
    }

    return query;
  }(),
  fetchItems: function () {
    var _fetchItems = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(query, limit) {
      var params, items, response, _response, filteredItems;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = {};
              params.limit = limit;
              params.resources = 'stednavne_v3';
              if (this.area) params.area = this.area;
              items = [];

              if (!query.isBlank) {
                _context3.next = 14;
                break;
              }

              params.search = "a b c d e f g h i j k l m n o p q r s t u v x y z æ ø å 0 1 2 3 4 5 6 7 8 9";
              params.limit += 100;
              _context3.next = 10;
              return fetch2(this.serviceUrl + '/Geosearch?service=GEO', {
                data: extend(params, this.authParams)
              });

            case 10:
              response = _context3.sent;

              if (response.data !== null) {
                items = response.data;
                items.sort(function (item1, item2) {
                  return item1.skrivemaade.localeCompare(item2.skrivemaade);
                });
                items = items.slice(0, limit);
              }

              _context3.next = 19;
              break;

            case 14:
              params.search = query.queryString;
              _context3.next = 17;
              return fetch2(this.serviceUrl + '/Geosearch?service=GEO', {
                data: extend(params, this.authParams)
              });

            case 17:
              _response = _context3.sent;
              if (_response.data !== null) items = _response.data;

            case 19:
              filteredItems = this.removeDuplicates(items);
              return _context3.abrupt("return", filteredItems);

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetchItems(_x4, _x5) {
      return _fetchItems.apply(this, arguments);
    }

    return fetchItems;
  }(),
  removeDuplicates: function removeDuplicates(items) {
    //https://ilikekillnerds.com/2016/05/removing-duplicate-objects-array-property-name-javascript/
    return items.filter(function (item, pos, arr) {
      return arr.map(function (mapObj) {
        return mapObj.id_lokalid;
      }).indexOf(item.id_lokalid) === pos;
    });
  },
  addItemAsResult: function addItemAsResult(results, item) {
    var navn = item.skrivemaade; // Enrich name with alternatives

    if (item.navnestatus === 'officielt' || item.navnestatus === 'suAutoriseret') {
      if (this.visUOfficiel && item.skrivemaader_uofficiel.length > 0) navn += ' (' + item.skrivemaader_uofficiel + ')';
    } else {
      if (item.skrivemaade_officiel.length > 0) navn += ' (' + item.skrivemaade_officiel + ')';
    } //Create a description


    var description = item.kvalifikation;
    var resultGeometry = this.translateWktToGeoJsonObject(item.geometryWkt);
    var result = results.addResult(this.source, this.type.id, navn, description, resultGeometry, item);
    result.id = item.id_lokalid;
  },

  /*
  async get(id) {
    params = extend(params, this.authParams);
    let data = await fetch2(this.serviceUrl + '?servicename=RestGeokeys_v2&method=matrikelnr&f=json&geometry=true', {data: params});
    let results = this.createQueryResult()
    let result = this.addFeatureAsResult(results, feature)
    return result
  },
  addFeatureAsResult(results, feature) {
    let {geometry, properties} = feature
    let result = results.addResult(this.source, this.type, navn, description, resultGeometry, feature)
    result.id = properties.id
    return result
  },
  */
  CLASS_NAME: 'Septima.Search.GeoStednavnSearcher'
});